export default "__VITE_ASSET__BG9bGbCl__"